import { createPageCountry } from './createPageCountry';
import { getAnalyticsRegionList } from './getAnalyticsRegionList';

type CountryField<T = number | string> = T | T[];

type StoryWithCountry = {
  country?: CountryField;
  pageCountry?: CountryField;
};

/**
 * У блоков страна находится в разных полях, определяем поля в этой функции.
 *
 * @returns Страну/страны через запятую и регион страны/регионы через запятую.
 */
export const createCountryInfo = async <T extends StoryWithCountry>(
  blok: T
) => {
  const countryField = blok?.country || blok?.pageCountry;

  const country =
    Array.isArray(countryField) &&
    countryField.length === 1 &&
    countryField[0] === 'none'
      ? undefined
      : createPageCountry(countryField);

  const pageRegion = await getAnalyticsRegionList(countryField);

  return {
    country,
    region: pageRegion,
  };
};
